import css from '../Approvals/css/view-modal.module.css';
import {AiOutlineFilePdf as PdfIcon} from 'react-icons/ai';
import styled from '@emotion/styled';
import EachPersonalField from './EachPersonField';
import Checkbox from '@mui/material/Checkbox';
import { TopManagementDetails} from './type';






  interface TopManagementProps {
    data?: TopManagementDetails;
  }

  const TopManagement = ({data}:TopManagementProps) => {

    return(
      <div className={css.contentDiv}>
        <p className={css.title}>Top Management Details</p>
        <EachQualificationContainer >
          <EachPersonalField style = {{width: '100%'}} label="Name Of Chief Executive / Director" value={data?.DirectorName} />
          <EachPersonalField style = {{width: '100%'}} label="EMAIL Of Chief Executive / Director" value={data?.DirectorEmail} />
          <EachPersonalField label="Phone Number" value={data?.Telephone} />
          <EachPersonalField label="Mobile Number" value={data?.MobilePhone} />
            <div  style = {{  padding:"5px 2px 10px",width: '100%', display: 'flex', gap: '40px',  marginInlineStart:'-10px'}}>
              <label >
                  <Checkbox  checked={true} /><span style={{color: '#666666'}}><span style={{fontWeight: '700', color: '#232323'}}>Declaration:</span></span> I hereby declare that the information provided above are correct 
              </label>
          </div>
          <EachPersonalField style = {{width: '100%'}} label="Representative Name" value={data?.RepName} />
          <EachPersonalField style = {{width: '100%'}} label="Designation" value={data?.RepDesignation}/>
        </EachQualificationContainer >
    </div>
    )
  }

  export default TopManagement


  const EachQualificationContainer = styled.div`
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  row-gap:20px;
  column-gap:10px;
  & > span{
    width: 100%;

  }
  & > span > span{
      padding:7px 10px;
      background-color:#E0FAEE;
      font-weight: 600;
  }
  & > div{
    width:40%;    
  }
`  

  const StyledLink = styled.a`
    margin-bottom: 20px;
    width:100%;
    padding:10px;
    display: flex;
    gap:20px;
    border-radius: 5px;
    border:1px dashed #D0CECE;
    text-decoration:none;
    color:#222;
    cursor: pointer;
    & > span{
      display: flex;
      justify-content:center;
      align-items: center;
      font-size:25px;
    }
    & > div{
      display: flex;
      flex-direction: column;
      gap:10px;
    }
    & > div > span:first-of-type{
      font-size: 13px;
    }
    & > div > span:last-of-type{
      color:#7B7A7A;
    }
`;